import React, { useState, useEffect } from 'react';
import { IoIosArrowBack } from 'react-icons/io';
import { MdOutlineCurrencyRupee } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { fetchWithAuth } from './authService';
import { API_ENDPOINTS } from '../utils/constants';

const History = () => {
  const navigate = useNavigate();
  const [profile, setprofile] = useState([]);
  const [list, setList] = useState(1);
  const [coins, setCoins] = useState([]);
  const [payment, setPayment] = useState([]);

  function goBack() {
    window.history.back();
  }

  const ClickOnList = ind => {
    setList(ind);
  };

  // Function to sort transactions by date (most recent first)
  const sortTransactionsByDate = transactions => {
    return transactions.sort(
      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    );
  };

  useEffect(() => {
    const fetchProfile = async () => {
      const token = localStorage.getItem('tringAuthToken');
      if (!token) {
        console.error('No auth token found');
        return;
      }

      try {
        const response = await fetchWithAuth(API_ENDPOINTS.USERS, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) throw new Error('Failed to fetch data');

        const data = await response.json();
        setprofile(data);
      } catch (error) {
        console.error('Error fetching songs:', error);
      }
    };

    fetchProfile();
  }, []);

  useEffect(() => {
    const fetchEvent = async () => {
      const token = localStorage.getItem('tringAuthToken');
      if (!token) {
        console.error('No auth token found');
        return;
      }

      try {
        const coinsresponse = await fetchWithAuth(API_ENDPOINTS.TRANSACTIONS, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (!coinsresponse.ok) throw new Error('Failed to fetch data');

        const text = await coinsresponse.text();

        if (!text) {
          console.log('Response body is empty.');
          return;
        }

        const data = JSON.parse(text);
        // Sort transactions by date (most recent first)
        const sortedCoins = sortTransactionsByDate(data);
        setCoins(sortedCoins);

        try {
          const paymentResp = await fetchWithAuth(
            API_ENDPOINTS.TRANSACTIONS_PAYMENTS,
            {
              method: 'GET',
              headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
              },
            }
          );

          if (!paymentResp.ok) throw new Error('Failed to Queue');

          const Pdata = await paymentResp.json();
          // Sort payment transactions by date (most recent first)
          const sortedPayments = sortTransactionsByDate(Pdata);
          setPayment(sortedPayments);
        } catch (error) {
          console.log('Error Fetching Queue,error');
        }
      } catch (error) {
        console.error('Error fetching Venue:', error);
      }
    };

    fetchEvent();
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('tringAuthToken');
    if (!token) {
      console.error('No auth token found');
      navigate('/');
      return;
    }
  }, [navigate]);

  // Helper function to get transaction display text based on type and orderId
  const getTransactionDisplayText = transaction => {
    if (transaction.orderId === 'SONG_REQUEST') {
      return transaction.type === 'rejected'
        ? 'Song Request (Rejected)'
        : 'Song Request';
    }
    if (transaction.orderId === 'SHOUT_OUT_REQUEST') {
      return transaction.type === 'rejected'
        ? 'Shout-out Request (Rejected)'
        : 'Shout-out Request';
    }
    return 'Purchased';
  };

  // Helper function to get coin display color and sign
  const getCoinDisplayInfo = transaction => {
    if (transaction.type === 'rejected') {
      return { color: 'green', sign: '+' }; // Refunded coins
    }
    if (
      transaction.orderId === 'SONG_REQUEST' ||
      transaction.orderId === 'SHOUT_OUT_REQUEST' ||
      transaction.type === 'debit'
    ) {
      return { color: '#CD141D', sign: '-' }; // Spent coins
    }
    return { color: 'green', sign: '+' }; // Purchased coins
  };

  return (
    <div className="px-3 d-flex flex-column" style={{ height: '100dvh' }}>
      <div className="d-flex flex-row justify-content-between align-items-center w-100 mb-2 mt-3">
        <div className="d-flex flex-row justify-content-center">
          <IoIosArrowBack
            className="mt-1"
            style={{ fontSize: '22px', marginRight: '10px' }}
            onClick={() => goBack()}
          />
          <h4 className="m-0" style={{ color: '#D0151C' }}>
            Coins History
          </h4>
        </div>
        <button
          onClick={() => navigate('/buy')}
          style={{
            border: 'none',
            color: '#BF1A2A',
            background: 'transparent',
            padding: 0,
            cursor: 'pointer',
          }}
        >
          Buy Coins
        </button>
      </div>

      <div
        className="w-100 my-2 d-flex flex-column align-items-start justify-content-center text-start"
        style={{
          backgroundImage: 'url(/images/buycoins.gif)',
          backgroundPosition: 'center',
          backgroundRepeat: 'none',
          backgroundSize: '100% 100%',
          height: '20dvh',
          minHeight: '20dvh',
          color: 'white',
          paddingLeft: '40vw',
        }}
      >
        <h4 style={{ margin: 0, marginBottom: '8px' }}>You Have</h4>
        <span
          style={{
            color: '#FED111',
            fontSize: 'clamp(0px,4.5vw,20px)',
          }}
        >
          <b>{profile.coins || 0}</b>
          <span style={{ color: '#FFF', fontSize: 'clamp(0px,4vw,18px)' }}>
            {' '}
            Tring Coins
          </span>
        </span>
      </div>

      <div
        className="w-100 d-flex flex-column"
        style={{
          flexGrow: 1,
          overflow: 'auto',
          overflowY: 'scroll',
          scrollBehavior: 'smooth',
        }}
      >
        <div
          className="w-100 d-flex flex-row"
          style={{ borderBottom: 'solid 1px #A1A1A133' }}
        >
          <span
            onClick={() => ClickOnList(1)}
            className="w-50 py-2"
            style={{
              color: list === 1 ? '#BF1A2A' : '#41414180',
              borderBottom:
                list === 1
                  ? 'solid 2px rgb(62, 62, 62)'
                  : 'solid 1px #41414180',
            }}
          >
            Coins
          </span>
          <span
            onClick={() => ClickOnList(2)}
            className="w-50 py-2"
            style={{
              color: list === 2 ? '#BF1A2A' : '#41414180',
              borderBottom:
                list === 2
                  ? 'solid 2px rgb(62, 62, 62)'
                  : 'solid 1px #41414180',
            }}
          >
            Payments
          </span>
        </div>

        <div
          className="w-100"
          style={{
            overflowY: 'scroll',
            overflowX: 'hidden',
            scrollBehavior: 'smooth',
            flexGrow: 1,
          }}
        >
          {list === 1 ? (
            <div>
              {coins.length === 0 ? (
                <div className="text-center mt-4">
                  <p style={{ color: '#868686' }}>
                    No transaction history available
                  </p>
                </div>
              ) : (
                <div className="mt-2">
                  {coins.map((trans, index) => {
                    const coinDisplayInfo = getCoinDisplayInfo(trans);

                    // Format orderId for display
                    const formatOrderId = orderId => {
                      switch (orderId) {
                        case 'SHOUT_OUT_REQUEST':
                          return 'ShoutOut Request';
                        case 'SONG_REQUEST':
                          return 'Song Request';
                        case 'FAST_TRACK':
                          return 'FastTrack';
                        default:
                          return orderId
                            .replace(/_/g, ' ')
                            .replace(/\b\w/g, c => c.toUpperCase());
                      }
                    };

                    return (
                      <div className="d-flex flex-column py-0" key={index}>
                        <div className="w-100 d-flex align-items-center">
                          {/* Left Section: Date + Order ID + Venue */}
                          <div
                            className="d-flex flex-row align-items-center"
                            style={{ gap: '15px', flexGrow: 1 }}
                          >
                            {/* Date Box */}
                            <div
                              className="px-2 py-1"
                              style={{
                                fontSize: 'clamp(0px,3vw,13px)',
                                color: '#DF0000',
                                border: 'solid 1px #868686',
                                borderRadius: '5px',
                                aspectRatio: '1/1',
                                fontWeight: 500,
                                width: 'clamp(0px,11vw,50px)',
                                height: 'clamp(0px,11vw,50px)',
                              }}
                            >
                              {new Date(trans?.createdAt).toLocaleString(
                                'en-US',
                                {
                                  day: '2-digit',
                                }
                              ) || '...'}
                              <br />
                              {new Date(trans?.createdAt).toLocaleString(
                                'en-US',
                                {
                                  month: 'short',
                                }
                              ) || '...'}
                            </div>

                            {/* Order Info */}
                            <div className="text-start">
                              <h5
                                style={{
                                  color: '#BB1C2D',
                                  margin: '0',
                                  fontSize: 'clamp(0px,4.3vw,17px)',
                                  fontWeight: 500,
                                }}
                              >
                                {formatOrderId(trans.orderId)}
                              </h5>
                              <span
                                style={{
                                  color: '#868686',
                                  fontSize: 'clamp(0px,3.3vw,12px)',
                                  whiteSpace: 'nowrap',
                                }}
                              >
                                {trans?.venue || ''}
                              </span>
                            </div>
                          </div>

                          {/* Right Section: Coins + Status */}
                          <div className="d-flex flex-column align-items-end ms-auto">
                            {/* Coin Amount + Image */}
                            <div
                              style={{
                                color: coinDisplayInfo.color,
                                fontSize: 'clamp(0px,4vw,17px)',
                                whiteSpace: 'nowrap',
                                fontWeight: 450,
                                display: 'flex',
                                alignItems: 'center',
                                gap: '5px',
                              }}
                            >
                              {coinDisplayInfo.sign}
                              {trans?.coins}{' '}
                            </div>

                            {/* Status Text */}
                            <span
                              style={{
                                fontSize: 'clamp(0px,3vw,12px)',
                                color: '#868686',
                                fontWeight: 400,
                                marginTop: '2px',
                              }}
                            >
                              {trans.type}
                            </span>
                          </div>
                        </div>
                        <hr className="my-2" />
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          ) : (
            <div>
              {payment.length === 0 ? (
                <div className="text-center mt-4">
                  <p style={{ color: '#868686' }}>
                    No payment history available
                  </p>
                </div>
              ) : (
                <div className="mt-2">
                  {payment.map((trans, index) => (
                    <div className="d-flex flex-column py-0" key={index}>
                      <div className="w-100 d-flex align-items-center">
                        {/* Left Section: Date + Transaction Info */}
                        <div
                          className="d-flex flex-row align-items-center"
                          style={{ gap: '15px', flexGrow: 1 }}
                        >
                          {/* Date Box */}
                          <div
                            className="px-2 py-1"
                            style={{
                              fontSize: 'clamp(0px,3vw,13px)',
                              color: '#DF0000',
                              border: 'solid 1px #868686',
                              borderRadius: '5px',
                              aspectRatio: '1/1',
                              fontWeight: 500,
                              width: 'clamp(0px,11vw,50px)',
                              height: 'clamp(0px,11vw,50px)',
                            }}
                          >
                            {new Date(trans?.createdAt).toLocaleString(
                              'en-US',
                              { day: '2-digit' }
                            ) || '...'}
                            <br />
                            {new Date(trans?.createdAt).toLocaleString(
                              'en-US',
                              { month: 'short' }
                            ) || '...'}
                          </div>

                          {/* Transaction Info */}
                          <div className="text-start">
                            <h5
                              style={{
                                color: '#BB1C2D',
                                margin: '0',
                                fontSize: 'clamp(0px,4.3vw,17px)',
                                fontWeight: 500,
                              }}
                            >
                              Coin Recharge
                            </h5>
                            <span
                              style={{
                                color: '#868686',
                                fontSize: 'clamp(0px,3.3vw,12px)',
                                whiteSpace: 'nowrap',
                              }}
                            >
                              Trans Id - {trans?.orderId || 'Unknown'}
                            </span>
                          </div>
                        </div>

                        {/* Right Section: Amount + Status */}
                        <div className="d-flex flex-column align-items-end ms-auto">
                          {/* Amount */}
                          <div
                            style={{
                              color: 'green',
                              fontSize: 'clamp(0px, 4vw, 17px)',
                              whiteSpace: 'nowrap',
                              fontWeight: 450,
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            <MdOutlineCurrencyRupee
                              style={{ marginBottom: '1px' }}
                            />
                            {trans?.price}
                          </div>

                          {/* Status Text */}
                          <span
                            style={{
                              fontSize: 'clamp(0px, 3vw, 12px)',
                              color: '#868686',
                              fontWeight: 400,
                              marginTop: '2px',
                            }}
                          >
                            Payment
                          </span>
                        </div>
                      </div>
                      <hr className="my-2" />
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default History;
